import React from "react";
import {
   makeStyles,
   Button,
   Container,
   Grid,
   TextField,
   Paper,
} from "@material-ui/core";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { FaStar } from "react-icons/fa";

const options = {
   loop: true,
   nav: false,
   margin: 15,
   center: true,
   dots: true,
   autoplay: false,
   responsive: {
      0: {
         items: 1,
      },
      768: {
         items: 2,
      },
      1000: {
         items: 3,
      },
   },
};
const useStyles = makeStyles((theme) => ({
   singleTesti: {
      margin: "0px 0px 30px",
   },
   clientText: {
      padding: "30px 30px",
      position: "relative",
      backgroundColor: "#fff",
      border: "1px solid #ddd",
      borderRadius: "4px",
      "& p": {
         color: "#5d6471",
      },
   },
   clientRating: {
      marginBottom: "15px",
      "& svg": {
         display: "inline-block",
         color: "#fec731",
         fontSize: "20px",
         padding: "0px 5px 0px 0px",
      },
   },
   testiImg: {
      position: "relative",
      marginTop: "20px",
      display: "block",
      overflow: "hidden",
      "& h4": {
         fontWeight: "600",
         textTransform: "capitalize",
         fontSize: "20px",
         marginBottom: "0px",
      },
   },
   guestRev: {
      fontWeight: "400",
   },
   SliderContent: {
      "& .owl-dots": {
         "& button": {
            outline: "none",
         },
         "& .active": {
            "& span": {
               background: "#50bba1 !important",
               width: "30px",
               borderRadius: "3px",
            },
         },
      },
   },
   TextContent: {
      textAlign: "center",
      marginBottom: "20px",
      "& h4": {
         display: "inline-block",
         fontSize: "28px",
         
         padding: "0 0 20px",
      },
      "& p": {
         fontSize: "20px",
         color: "#5d6471",
      },
   },
}));
const Slider = () => {
   const Style = useStyles();
   return (
      <>
         <Container fixed>
            <div className={Style.SliderContent}>
            <div className={Style.ServiceContent}>
                        <div className={Style.TextContent}>
                           <h4>Customer say some words</h4>
                           <p>
                              Help agencies to define their new business objectives and then create professional software.
                           </p>
                        </div>
                     </div>
               <OwlCarousel className="owl-theme" {...options}>
                  <div class="item">
                     <div className={Style.singleTesti}>
                        <div className={Style.testiText}>
                           <div className={Style.clientText}>
                              <div className={Style.clientRating}>
                                 <FaStar />
                                 <FaStar />
                                 <FaStar />
                                 <FaStar />
                                 <FaStar />
                              </div>
                              <p>
                              The team of Aayog Infotech have done great things for my project and have surpass my belief many times. They have been great to work with and I will definitely work with them again & highly recommend!

                              </p>
                              <div className={Style.testiImg}>
                                 <div className={Style.guestDetails}>
                                    <h4>Jonathan P ,</h4>
                                    <span className={Style.guestRev}>
                                       CEO
                                    </span>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="item">
                     <div className={Style.singleTesti}>
                        <div className={Style.testiText}>
                           <div className={Style.clientText}>
                              <div className={Style.clientRating}>
                                 <FaStar />
                                 <FaStar />
                                 <FaStar />
                                 <FaStar />
                                 <FaStar />
                              </div>
                              <p>
                              The team of Aayog Infotech have done great things for my project and have surpass my belief many times. They have been great to work with and I will definitely work with them again & highly recommend!

                              </p>
                              <div className={Style.testiImg}>
                                 <div className={Style.guestDetails}>
                                    <h4>Sheldon J ,
</h4>
                                    <span className={Style.guestRev}>
                                    Product Manager
                                    </span>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="item">
                     <div className={Style.singleTesti}>
                        <div className={Style.testiText}>
                           <div className={Style.clientText}>
                              <div className={Style.clientRating}>
                                 <FaStar />
                                 <FaStar />
                                 <FaStar />
                                 <FaStar />
                                 <FaStar />
                              </div>
                              <p>
                              We are very pleased with the upshot of the website. We are very impressed with the way team has worked to accommodate our needs and wishes! It is a pleasure to work with a web design company as professional as yours!

                              </p>
                              <div className={Style.testiImg}>
                                 <div className={Style.guestDetails}>
                                    <h4>Larry J. ,
</h4>
                                    <span className={Style.guestRev}>
                                    Product Manager
                                    </span>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="item">
                     <div className={Style.singleTesti}>
                        <div className={Style.testiText}>
                           <div className={Style.clientText}>
                              <div className={Style.clientRating}>
                                 <FaStar />
                                 <FaStar />
                                 <FaStar />
                                 <FaStar />
                                 <FaStar />
                              </div>
                              <p>
                                 When replacing a multi-lined selection of text,
                                 the generated dummy text maintains the amount
                                 of lines. When replacing a selection. help
                                 agencies.
                              </p>
                              <div className={Style.testiImg}>
                                 <div className={Style.guestDetails}>
                                    <h4>Edward</h4>
                                    <span className={Style.guestRev}>
                                       guest-rev
                                    </span>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  
               </OwlCarousel>
            </div>
         </Container>
      </>
   );
};

export default Slider;
